"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivatePremiumCompanyProfileBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
const elements_1 = require("@src/components/elements");
const react_router_dom_1 = require("react-router-dom");
const premium_company_profile_modal_context_1 = require("@src/context/premium-company-profile-modal-context");
const CompanyPremiumElementWrapper_1 = require("../CompanyPremiumElementWrapper");
const ActivatePremiumCompanyProfileBanner = ({ shouldBeHiddenIfPremiumIsActive, hasActivePremiumSubscription, }) => {
    const [isPremiumBannerHovered, setIsPremiumBannedHovered] = react_1.default.useState(false);
    const { setIsPremiumCompanyProfileSubscriptionModalOpen } = (0, premium_company_profile_modal_context_1.usePremiumCompanyProfileModalContextValue)();
    const history = (0, react_router_dom_1.useHistory)();
    const onClickHandler = () => {
        if (!hasActivePremiumSubscription) {
            setIsPremiumCompanyProfileSubscriptionModalOpen(true);
            return;
        }
        history.pushLocalized('/admin/premium-firemny-profil');
    };
    return ((0, jsx_runtime_1.jsx)(CompanyPremiumElementWrapper_1.CompanyPremiumElementWrapper, { shouldBeHiddenIfPremiumIsActive: shouldBeHiddenIfPremiumIsActive, hasActivePremiumSubscription: hasActivePremiumSubscription, onClick: onClickHandler, children: (0, jsx_runtime_1.jsx)(MainContentWrapper, { onMouseEnter: () => setIsPremiumBannedHovered(true), onMouseLeave: () => setIsPremiumBannedHovered(false), children: (0, jsx_runtime_1.jsxs)(StyledBanner, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.activate_premium_profile" }), (0, jsx_runtime_1.jsx)(PremiumDiamondWrapper, { isPremiumBannerHovered: isPremiumBannerHovered, children: (0, jsx_runtime_1.jsx)(elements_1.PremiumIcon, { width: 16, height: 16 }) })] }) }) }));
};
exports.ActivatePremiumCompanyProfileBanner = ActivatePremiumCompanyProfileBanner;
const MainContentWrapper = styled_components_1.default.div `
	position: relative;
	background: ${({ theme }) => theme.color.brandDarkBlue};
	transition: all 0.3s ease;
	color: ${({ theme }) => theme.color.white};
	border-radius: 0.5rem;
	:hover {
		background: ${({ theme }) => (0, polished_1.lighten)(0.1, theme.color.brandDarkBlue)};
	}
`;
const StyledBanner = styled_components_1.default.div `
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9rem;
	padding: 0.5rem 0;
	text-transform: uppercase;
`;
const PremiumDiamondWrapper = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gold};
	border: 2px solid ${({ theme }) => theme.color.gold};
	background: ${({ theme }) => (0, polished_1.transparentize)(0.4, theme.color.gold)};
	border-radius: 1rem;
	width: 1.5rem;
	height: 1.5rem;
	min-width: 1.5rem;
	min-height: 1.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 0.5rem;
`;
